/** @format */

import {useEffect, useState} from 'react';

import {styled} from '@mui/material/styles';

import {Trans} from 'react-i18next';
import {Typography} from '@mui/material';
import {useLocation} from 'react-router-dom';

import {
  useGetCurrentUserErrorQuery,
  useHidePaymentErrorMutation,
} from 'components/banners/graphql/__generated__';

import ErrorBanner from './ErrorBanner';

const PREFIX = 'PaymentErrorBanner';

const classes = {
  text: `${PREFIX}-text`,
  link: `${PREFIX}-link`,
};

const StyledErrorBanner = styled(ErrorBanner)(({theme}) => ({
  [`& .${classes.text}`]: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '16px',
  },

  [`& .${classes.link}`]: {
    ...theme.custom_typography.link,
    color: theme.palette.text.primary,
  },
}));

const VALID_PATHS = ['/home/main/status'];

const PaymentErrorBanner = () => {
  const location = useLocation();

  const [show, setShow] = useState(true);

  const skip = !VALID_PATHS.includes(location.pathname);

  const {loading, error, data} = useGetCurrentUserErrorQuery({skip});
  const [hidePaymentError] = useHidePaymentErrorMutation();

  useEffect(() => {
    if (!data?.currentUser) return;
    setShow(data.currentUser.isPaymentError);
  }, [data]);

  if (loading || error) return null;

  if (skip) return null;
  if (!data?.currentUser?.isPaymentError || !show) return null;

  const handleClose = async () => {
    await hidePaymentError();
    setShow(false);
  };

  return (
    <StyledErrorBanner onClose={handleClose}>
      <Typography className={classes.text}>
        <Trans>
          Не удалось списать оплату и проверки по новым кабинетам не будут запущены. Попробуйте
          снова
        </Trans>
      </Typography>
    </StyledErrorBanner>
  );
};

export default PaymentErrorBanner;
